import { put, call, takeLatest } from 'redux-saga/effects'; 
import { 
    GET_PRESCRIPTIONS_COMPLETE,
    GET_PRESCRIPTIONS_ERROR, 
    GET_PRESCRIPTIONS_START,
    CREATE_NEW_PRESCRIPTION_COMPLETE,
    CREATE_NEW_PRESCRIPTION_ERROR,
    CREATE_NEW_PRESCRIPTION_START
} 
from '../../consts/actionTypes';

import { apiCall } from '../api';

export function* getPrescriptions({payload}) {
    try {
        let url = '/api/prescriptions'
        if (payload.prescripton_id) {
            url = `/api/prescriptions/${payload.prescripton_id}`
        }
                
        let args = {}
        if (payload.name) { args.search = payload.name }
        if (payload.limit) { args.limit = payload.limit }
        if (payload.pageNumber) { args.page = payload.pageNumber }

        if (args) {
            url = `${url}?${new URLSearchParams(args).toString()}`
        }

        const results = yield call(apiCall, url, null, null, 'GET');
        yield put({ type: GET_PRESCRIPTIONS_COMPLETE, results, name: payload.name, reset: payload.reset});
    } catch (error) {
        yield put({ type: GET_PRESCRIPTIONS_ERROR, error});
    }
}

export function* createPrescription({payload}) {
    try {
        const {patient_id} = payload;

        const results = yield call(apiCall, `/api/patients/${patient_id}/prescriptions`, payload, null, 'POST');
        if (results.status == 200) {
            yield put({ type: CREATE_NEW_PRESCRIPTION_COMPLETE, results});
        } else {
            yield put({ type: CREATE_NEW_PRESCRIPTION_ERROR, results});
        }        

    } catch (error) {
        yield put({ type: CREATE_NEW_PRESCRIPTION_ERROR, error});
    }
}



export default function* prescriptions() {
    yield takeLatest(GET_PRESCRIPTIONS_START, getPrescriptions);
    yield takeLatest(CREATE_NEW_PRESCRIPTION_START, createPrescription);
}

